/**
 * Reminder shown ABOVE the breathing capsule during the inspiration phase
 * for CO2-desensitization exercises (Buteyko, Box, Reduce Frequency,
 * Alternate Nostril). Reminds the patient to inhale SOFTLY with a SMALL
 * volume — the key to raising CO2 tolerance. Same font size as the phase
 * label pill shown below the capsule for visual consistency.
 *
 * Positioned absolute inside the capsule's `.relative` wrapper so it does
 * not shift the capsule's vertical alignment within the 3-column grid.
 */
const InhalationGentleWarning = ({ visible }) => {
  if (!visible) return null;
  return (
    <div
      className="absolute left-1/2 -translate-x-1/2 bottom-full mb-3 bg-sky-100/95 backdrop-blur rounded-xl px-5 py-1.5 shadow border border-sky-300 whitespace-nowrap"
      data-testid="inhale-gentle-warning"
    >
      <span className="text-base font-semibold text-sky-800">
        ⚠ Inspirer doucement, PETIT Volume !
      </span>
    </div>
  );
};

export default InhalationGentleWarning;
